import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { BusquedaTesoroPage } from './busqueda-tesoro';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
  declarations: [
    BusquedaTesoroPage,
  ],
  imports: [
    IonicPageModule.forChild(BusquedaTesoroPage),
    ComponentsModule
  ],
})
export class BusquedaTesoroPageModule {}



// WEBPACK FOOTER //
// ./src/pages/busqueda-tesoro/busqueda-tesoro.module.ts